import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { CommonMoreMenu } from '../../../components';
import { PATH_DASHBOARD } from '../../../app';
import { DeviationCode } from '../../../types';
import { useOnItemClick } from '../../../hooks/useOnItemClick';

type CELL = {
  name: string,
  render?: (data: DeviationCode, cell: CELL) => string,
}

type DeviationCodeItemProps = {
  data: DeviationCode,
  onDelete: (id: number) => void,
}

const CELLS: CELL[] = [
  {
    name: 'id',
  },
  {
    name: 'name',
  },
  {
    name: 'code',
  },
  {
    name: 'class',
  },
];

const TableRowStyles = {
  cursor: 'pointer',
};

const UPDATING_LINK = PATH_DASHBOARD.deviationCodes.root;

export const DeviationCodeItem: React.FC<DeviationCodeItemProps> = ({
  data,
  onDelete,
}): JSX.Element => {
  const { onItemClick } = useOnItemClick(UPDATING_LINK, data.id);

  return (
    <TableRow
      hover
      sx={TableRowStyles}
    >
      {CELLS.map((cell) => (
        <TableCell
          key={cell.name}
          onClick={onItemClick}
        >
          {cell.render ? cell.render(data, cell) : data[cell.name]}
        </TableCell>
      ))}
      <TableCell align="right">
        <CommonMoreMenu
          itemId={data.id}
          updatingLink={UPDATING_LINK}
          onDelete={onDelete}
        />
      </TableCell>
    </TableRow>
  );
};
